import { DeepPartial, PartialsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_PARTIALS_CONFIG: DeepPartial<PartialsConfig> = {
  components: {
    partial: {
      grid: 'GoccoSlidingPanel'

    }
  }

};
export const DESKTOP_PARTIALS_CONFIG: DeepPartial<PartialsConfig> = {
  gridColumns: 4
};
